import { useState, useEffect } from 'react';



const CONSTANTS = {
    PROJECT_NAME: 'Paytm Blink Checkout JS',
    ENV: {
        PROD: 'PROD',
        DEV: 'STAGE'
    },
    HOSTS: {
        PROD: 'https://securegw.paytm.in',
        DEV: 'https://securegw-stage.paytm.in'
    },
    LINKS: {
        CHECKOUT_JS_URL: '/merchantpgpui/checkoutjs/merchants/'
    },
    ERRORS: {
        INIT: 'An error during initialization!',
        INVOKE: 'An error during invoking!',
        MERCHANT_ID_NOT_FOUND: 'Please provide merchant id!',
        CHECKOUT_NOT_AVAILABLE: 'Checkout JS library not found. Please make sure you have included checkout js!',
        INVALID_CHECKOUT_JS_INSTANCE: 'Invalid instance provided!',
        FAILED_TO_LOAD_SCRIPT: 'Failed to load script!'
    },
    IDS: {
        CHECKOUT_ELEMENT: 'paytm-checkout-wrapper-'
    }
};


type paytmCheckOutJS = {
    init?: (config: any) => Promise<any>;
    invoke: () => void;
    onLoad: (callback: () => void) => void;
    close: () => void;
}

declare global {
    interface Window {
        Paytm: undefined | {
            CheckoutJS: paytmCheckOutJS
        };
    }
}



function PaytmCheckOut() {
    const [isLoading, setIsLoading] = useState(true);
    const [checkoutJsInstance, setCheckoutJsInstance] = useState<paytmCheckOutJS>({} as paytmCheckOutJS);

    const MERCHANT_ID = import.meta.env.VITE_PAYTM_MID;
    const ENV = import.meta.env.VITE_MODE;

    const loadCheckoutScript = () => {
        const scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.src = CONSTANTS.HOSTS[ENV] + CONSTANTS.LINKS.CHECKOUT_JS_URL.concat(MERCHANT_ID);
        scriptElement.type = 'application/javascript';
        scriptElement.onload = () => {
            const checkoutJsInstance = window.Paytm?.CheckoutJS;

            if (!checkoutJsInstance) {
                console.error(CONSTANTS.ERRORS.CHECKOUT_NOT_AVAILABLE);
                setIsLoading(false);
                return;
            }

            if (checkoutJsInstance.onLoad) {
                checkoutJsInstance.onLoad(() => {
                    if ( checkoutJsInstance && checkoutJsInstance.init ) {
                        setCheckoutJsInstance(checkoutJsInstance);
                        // console.log("checkoutJsInstance", checkoutJsInstance);
                    }
                    setIsLoading(false);
                });
            }

        };
        scriptElement.onerror = () => {
            console.error('script load fail!');
            setIsLoading(false);
        }

        document.body.appendChild(scriptElement);
    }
    
    useEffect(() => {
        loadCheckoutScript();
    }, [])

    return { checkoutJsInstance, isLoading }
}

export default PaytmCheckOut